;(function (angular) {
  'use strict'

  angular
    .module('kilo.config')
    .constant('chorusStatuses', [
      {
        value: 'MISE_A_DISPOSITION',
        label: 'Mise à disposition'
      },
      {
        value: 'SERVICE_FAIT',
        label: 'Service fait'
      },
      {
        value: 'MANDATEE',
        label: 'Mandatée'
      },
      {
        value: 'MISE_A_DISPOSITION_COMPTABLE',
        label: 'Mise à disposition comptable'
      },
      {
        value: 'COMPTABILISEE',
        label: 'Comptabilisée'
      },
      {
        value: 'MISE_EN_PAIEMENT',
        label: 'Mise en paiement'
      },
      {
        value: 'COMPLETEE',
        label: 'Complétée'
      },
      {
        value: 'REJETEE',
        label: 'Rejetée'
      },
      {
        value: 'DEPOSEE',
        label: 'Déposée'
      }
    ])
})(window.angular)
